<div class="screen screen--settings">

  <header class="gate__head">
    <button class="gate__back" type="button" data-id="back" aria-label="<%= _lcs( 'Zurück' ) %>">
      <i class="icon icon--arrow-left"></i>
    </button>
  </header>

  <header class="screen__head">
    <p class="belturo-eyebrow"><%= _lcs( 'Dein Konto' ) %></p>
    <h1 class="screen__title"><%= _lcs( 'Einstellungen' ) %></h1>
  </header>

  <!-- Push notifications from the house — for every guest, account or not.
       Filled by SettingsState once the device's state is known. -->
  <section class="settings__card" data-id="push-card" hidden>
    <h2 class="settings__title"><i class="icon icon--bell"></i> <%= _lcs( 'Benachrichtigungen' ) %></h2>

    <label class="switch-row" data-id="push-row" hidden>
      <input type="checkbox" data-id="push-toggle" />
      <span class="switch"><span class="switch__knob"></span></span>
      <span class="switch-row__label"><%= _lcs( 'Neuigkeiten vom Gastgeber erhalten' ) %></span>
    </label>

    <span class="settings__help" data-id="push-help"></span>
  </section>

  <% if ( isAnonymous ) { %>

  <div class="gate__body">
    <span class="gate__icon"><i class="icon icon--user-round"></i></span>
    <h2 class="gate__title"><%= _lcs( 'Du nutzt die App ohne Konto' ) %></h2>
    <p class="gate__text"><%= _lcs( 'Mit einem Konto kannst du deinen Namen und dein Passwort hier verwalten.' ) %></p>
    <div class="gate__actions">
      <button class="btn btn--primary btn--lg btn--block" type="button" data-id="signup"><%= _lcs( 'Konto erstellen' ) %></button>
      <button class="btn btn--secondary btn--lg btn--block" type="button" data-id="login"><%= _lcs( 'Anmelden' ) %></button>
    </div>
  </div>

  <% } else { %>

  <form class="settings__card" data-id="name-form" novalidate>
    <h2 class="settings__title"><i class="icon icon--user-round"></i> <%= _lcs( 'Dein Name' ) %></h2>

    <div class="field">
      <label class="field__label" for="settings-name"><%= _lcs( 'Name' ) %></label>
      <div class="field__control">
        <span class="field__icon"><i class="icon icon--user-round"></i></span>
        <input class="field__input" id="settings-name" name="name" type="text" maxlength="120"
               autocomplete="name" value="<%= name %>" required />
      </div>
    </div>

    <div class="field">
      <span class="field__label"><%= _lcs( 'E-Mail' ) %></span>
      <div class="field__control field__control--static">
        <span class="field__icon"><i class="icon icon--mail"></i></span>
        <span class="field__static"><%= email %></span>
      </div>
    </div>

    <p class="planform__error" data-id="form-error" role="alert" hidden></p>

    <button class="btn btn--primary btn--lg btn--block" type="submit">
      <i class="icon icon--check"></i> <%= _lcs( 'Name speichern' ) %>
    </button>
  </form>

  <form class="settings__card" data-id="password-form" novalidate autocomplete="on">
    <h2 class="settings__title"><i class="icon icon--key-round"></i> <%= _lcs( 'Passwort ändern' ) %></h2>

    <!-- Lets password managers file the new password under the right account. -->
    <input type="email" name="username" autocomplete="username" value="<%= email %>" hidden />

    <div class="field">
      <label class="field__label" for="pw-current"><%= _lcs( 'Aktuelles Passwort' ) %></label>
      <div class="field__control">
        <span class="field__icon"><i class="icon icon--lock"></i></span>
        <input class="field__input" id="pw-current" name="currentPassword" type="password"
               autocomplete="current-password" required />
        <button class="field__toggle" type="button" data-toggle="pw-current"
                aria-label="<%= _lcs( 'Passwort anzeigen' ) %>" aria-pressed="false">
          <i class="icon icon--eye"></i>
        </button>
      </div>
    </div>

    <div class="field">
      <label class="field__label" for="pw-new"><%= _lcs( 'Neues Passwort' ) %></label>
      <div class="field__control">
        <span class="field__icon"><i class="icon icon--key-round"></i></span>
        <input class="field__input" id="pw-new" name="newPassword" type="password"
               autocomplete="new-password" minlength="<%= minLength %>" required />
        <button class="field__toggle" type="button" data-toggle="pw-new"
                aria-label="<%= _lcs( 'Passwort anzeigen' ) %>" aria-pressed="false">
          <i class="icon icon--eye"></i>
        </button>
      </div>
      <span class="settings__help"><%= _lcs( 'Mindestens {count} Zeichen.', { count: minLength } ) %></span>
    </div>

    <div class="field">
      <label class="field__label" for="pw-repeat"><%= _lcs( 'Neues Passwort wiederholen' ) %></label>
      <div class="field__control">
        <span class="field__icon"><i class="icon icon--key-round"></i></span>
        <input class="field__input" id="pw-repeat" name="repeatPassword" type="password"
               autocomplete="new-password" required />
        <button class="field__toggle" type="button" data-toggle="pw-repeat"
                aria-label="<%= _lcs( 'Passwort anzeigen' ) %>" aria-pressed="false">
          <i class="icon icon--eye"></i>
        </button>
      </div>
    </div>

    <p class="planform__error" data-id="form-error" role="alert" hidden></p>

    <button class="btn btn--primary btn--lg btn--block" type="submit">
      <i class="icon icon--check"></i> <%= _lcs( 'Passwort ändern' ) %>
    </button>
  </form>

  <% } %>

</div>
